import React, {useEffect, useState} from "react";
import {DataTable, Modal, P, Spinner} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import AcpSettingsService from "../services/AcpSettingsService";
import {AcpSettingsDTO} from "../types/AcpSettingsDTO";
import { ProjectAccents } from "../../General/config/projectAccents";

function AcpIntegrationDetails(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, setLoading: Function }) {
    
    const [loading, setLoading] = useState<boolean>();
    const [acpDetails, setAcpDetails] = useState<AcpSettingsDTO[]>([]);
    
    useEffect(() => {
        setLoading(true);
        AcpSettingsService.getAcpSettingsForCustomer(props.selectedCustomer.clientId, props.selectedCustomer.environmentName)
            .then((e) => {
                setAcpDetails(e)
                setLoading(false)
            })
    }, [props.selectedCustomer.clientId, props.selectedCustomer.environmentName]);

    const columns = React.useMemo(
        () => [
            { accessorKey: 'description', header: 'Description' },
            { accessorKey: 'ftpName', header: 'FTP Login'}
        ],
        [],
    );
    
    const renderModalContent = () => {
        if (loading) {
            return <Spinner />;
        }
        return (
            <>
                <DataTable
                    columns={columns}
                    data={acpDetails}
                    noDataElement={<P>Sorry, there is no FTP Data available.</P>}
                />
            </>
        )
    }
    
    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PeoplePlanner}
            heading={`ACP Integration Details`}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default AcpIntegrationDetails;
